import { Branch, Unit, Student, Note, Application, Activity, DashboardStats, UnitType, Document } from '../types';
import { Deadline, DeadlineNotification, Proposal, Dealer } from '../types';

export const mockBranches: Branch[] = [
  {
    id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    name: 'İstanbul Merkez Şubesi',
    code: 'IST001',
    city: 'İstanbul',
    region: 'Marmara',
    contactPerson: 'Mehmet Yılmaz',
    email: 'istanbul@pisaeducazione.com',
    phone: '+90 212 555 0001',
    address: 'Levent Mahallesi, Büyükdere Cad. No:123, Şişli/İstanbul',
    isActive: true,
    createdAt: new Date('2023-01-15'),
    totalStudents: 245,
    monthlyTarget: 50,
    currentMonthApplications: 38,
    currentMonthRegistrations: 25,
    units: []
  },
  {
    id: 'b1ffcd88-8b1a-3df7-aa5c-5aa8ac270b22',
    name: 'Ankara Şubesi',
    code: 'ANK001',
    city: 'Ankara',
    region: 'İç Anadolu',
    contactPerson: 'Ayşe Demir',
    email: 'ankara@pisaeducazione.com',
    phone: '+90 312 555 0002',
    address: 'Çankaya Mahallesi, Atatürk Bulvarı No:456, Çankaya/Ankara',
    isActive: true,
    createdAt: new Date('2023-02-20'),
    totalStudents: 189,
    monthlyTarget: 40,
    currentMonthApplications: 32,
    currentMonthRegistrations: 20,
    units: []
  },
  {
    id: 'c2ggde77-7a29-2ce6-99bb-4bb7bd381c33',
    name: 'İzmir Şubesi',
    code: 'IZM001',
    city: 'İzmir',
    region: 'Ege',
    contactPerson: 'Murat Kaya',
    email: 'izmir@pisaeducazione.com',
    phone: '+90 232 555 0003',
    address: 'Alsancak Mahallesi, Kordon Cad. No:789, Konak/İzmir',
    isActive: true,
    createdAt: new Date('2023-03-10'),
    totalStudents: 156,
    monthlyTarget: 35,
    currentMonthApplications: 28,
    currentMonthRegistrations: 18,
    units: []
  },
  {
    id: 'd3hhef66-6938-1bd5-88aa-3aa6ac492d44',
    name: 'Antalya Şubesi',
    code: 'ANT001',
    city: 'Antalya',
    region: 'Akdeniz',
    contactPerson: 'Selin Özkan',
    email: 'antalya@pisaeducazione.com',
    phone: '+90 242 555 0004',
    address: 'Konyaaltı Mahallesi, Atatürk Cad. No:321, Konyaaltı/Antalya',
    isActive: true,
    createdAt: new Date('2023-04-05'),
    totalStudents: 134,
    monthlyTarget: 30,
    currentMonthApplications: 25,
    currentMonthRegistrations: 15,
    units: []
  },
  {
    id: 'e4iifg55-5847-0ac4-7799-2996bd5a3e55',
    name: 'Bursa Şubesi',
    code: 'BUR001',
    city: 'Bursa',
    region: 'Marmara',
    contactPerson: 'Emre Yıldırım',
    email: 'bursa@pisaeducazione.com',
    phone: '+90 224 555 0005',
    address: 'Osmangazi Mahallesi, Cumhuriyet Cad. No:654, Osmangazi/Bursa',
    isActive: true,
    createdAt: new Date('2023-04-20'),
    totalStudents: 98,
    monthlyTarget: 25,
    currentMonthApplications: 19,
    currentMonthRegistrations: 10,
    units: []
  },
  {
    id: 'f5aa9c77-6958-4be5-8800-3007ce6c4f77',
    name: 'İstanbul Kadıköy Şubesi',
    code: 'ISTKAD001',
    city: 'İstanbul',
    region: 'Marmara',
    contactPerson: 'Leyla Şahin',
    email: 'kadikoy@pisaeducazione.com',
    phone: '+90 216 555 0006',
    address: 'Caferağa Mahallesi, Moda Cad. No:234, Kadıköy/İstanbul',
    isActive: true,
    createdAt: new Date('2024-01-10'),
    totalStudents: 87,
    monthlyTarget: 30,
    currentMonthApplications: 22,
    currentMonthRegistrations: 12,
    units: []
  }
];

export const mockUnits: Unit[] = [
  {
    id: 'f5jjgh44-4756-9fb3-6688-1885ce6b4f66',
    name: 'Eğitim Danışmanlığı',
    type: 'education_consultant',
    branchId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    manager: 'Fatma Özkan',
    email: 'egitim.istanbul@pisaeducazione.com',
    phone: '+90 216 555 0101',
    isActive: true,
    createdAt: new Date('2023-03-10'),
    totalStudents: 89,
    monthlyTarget: 20,
    currentMonthApplications: 15,
    specializations: ['Üniversite Seçimi', 'Program Danışmanlığı', 'Kariyer Planlama'],
    description: 'Öğrencilere üniversite ve program seçimi konusunda danışmanlık hizmeti veren birim',
    location: 'İstanbul Merkez - 2. Kat',
    workingHours: '09:00 - 18:00',
    capacity: 50,
    employees: [
      {
        id: 'emp-1',
        userId: 'user-3',
        name: 'Fatma Özkan',
        email: 'fatma.ozkan@pisaeducazione.com',
        phone: '+90 555 111 2233',
        position: 'Birim Müdürü',
        joinDate: new Date('2023-03-10'),
        isActive: true,
        permissions: ['manage_unit', 'view_all_students', 'edit_students'],
        responsibleUniversities: [
          'Politecnico di Milano',
          'Università Bocconi',
          'Università Statale Milano',
          'Università Cattolica del Sacro Cuore',
          'Università di Roma La Sapienza',
          'Università di Bologna',
          'Università di Pisa',
          'Università di Genova'
        ],
        workload: 85,
        performance: {
          monthlyTarget: 12,
          achieved: 10,
          successRate: 83
        }
      },
      {
        id: 'emp-2',
        userId: 'user-8',
        name: 'Mehmet Arslan',
        email: 'mehmet.arslan@pisaeducazione.com',
        phone: '+90 555 444 5566',
        position: 'Kıdemli Eğitim Danışmanı',
        joinDate: new Date('2023-06-15'),
        isActive: true,
        permissions: ['view_students', 'edit_students'],
        responsibleUniversities: [
          'Università di Padova',
          'Università di Firenze',
          'Università di Torino',
          'Università di Napoli Federico II',
          'Università Ca\' Foscari Venezia',
          'Università di Perugia'
        ],
        workload: 72,
        performance: {
          monthlyTarget: 8,
          achieved: 6,
          successRate: 75
        }
      },
      {
        id: 'emp-3',
        userId: 'user-9',
        name: 'Seda Yılmaz',
        email: 'seda.yilmaz@pisaeducazione.com',
        position: 'Eğitim Danışmanı',
        joinDate: new Date('2023-09-01'),
        isActive: true,
        permissions: ['view_students', 'edit_students'],
        responsibleUniversities: [
          'Università di Siena',
          'Università di Palermo',
          'Università di Bari',
          'Università di Catania',
          'Università di Verona'
        ],
        workload: 68,
        performance: {
          monthlyTarget: 6,
          achieved: 5,
          successRate: 83
        }
      }
    ]
  },
  {
    id: 'g6kkhi33-3665-8ea2-5577-0774df7c5g77',
    name: 'Vize Danışmanlığı',
    type: 'visa_consultant',
    branchId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    manager: 'Can Kaya',
    email: 'vize.istanbul@pisaeducazione.com',
    phone: '+90 212 555 0102',
    isActive: true,
    createdAt: new Date('2023-04-05'),
    totalStudents: 67,
    monthlyTarget: 15,
    currentMonthApplications: 12,
    specializations: ['Öğrenci Vizesi', 'Schengen Vizesi', 'Vize Başvuru Süreci'],
    description: 'Öğrencilerin vize başvuru süreçlerini yöneten ve takip eden birim',
    location: 'İstanbul Merkez - 3. Kat',
    workingHours: '09:00 - 18:00',
    capacity: 40,
    employees: [
      {
        id: 'emp-4',
        userId: 'user-4',
        name: 'Can Kaya',
        email: 'can.kaya@pisaeducazione.com',
        phone: '+90 555 777 8899',
        position: 'Birim Müdürü',
        joinDate: new Date('2023-04-05'),
        isActive: true,
        permissions: ['manage_unit', 'view_all_applications', 'approve_documents'],
        workload: 78,
        performance: {
          monthlyTarget: 10,
          achieved: 8,
          successRate: 80
        }
      },
      {
        id: 'emp-5',
        userId: 'user-10',
        name: 'Ayşe Demir',
        email: 'ayse.demir@pisaeducazione.com',
        position: 'Vize Uzmanı',
        joinDate: new Date('2023-07-20'),
        isActive: true,
        permissions: ['view_applications', 'review_documents'],
        workload: 65,
        performance: {
          monthlyTarget: 5,
          achieved: 4,
          successRate: 80
        }
      }
    ]
  },
  {
    id: 'h7llij22-2574-7d91-4466-9663eg8d6h88',
    name: 'Pazarlama',
    type: 'marketing',
    branchId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    manager: 'Elif Yıldırım',
    email: 'pazarlama.istanbul@pisaeducazione.com',
    phone: '+90 212 555 0103',
    isActive: true,
    createdAt: new Date('2023-04-10'),
    totalStudents: 0,
    monthlyTarget: 100,
    currentMonthApplications: 85,
    specializations: ['Dijital Pazarlama', 'Sosyal Medya', 'Etkinlik Yönetimi'],
    description: 'Dijital pazarlama kampanyaları ve lead üretimi yapan birim',
    location: 'İstanbul Merkez - 1. Kat',
    workingHours: '09:00 - 18:00',
    capacity: 30,
    employees: [
      {
        id: 'emp-6',
        userId: 'user-5',
        name: 'Elif Yıldırım',
        email: 'elif.yildirim@pisaeducazione.com',
        position: 'Pazarlama Müdürü',
        joinDate: new Date('2023-04-10'),
        isActive: true,
        permissions: ['manage_campaigns', 'view_analytics', 'manage_content'],
        workload: 82,
        performance: {
          monthlyTarget: 50,
          achieved: 42,
          successRate: 84
        }
      },
      {
        id: 'emp-7',
        userId: 'user-11',
        name: 'Murat Özkan',
        email: 'murat.ozkan@pisaeducazione.com',
        position: 'Dijital Pazarlama Uzmanı',
        joinDate: new Date('2023-08-01'),
        isActive: true,
        permissions: ['manage_campaigns', 'view_analytics'],
        workload: 75,
        performance: {
          monthlyTarget: 30,
          achieved: 25,
          successRate: 83
        }
      }
    ]
  },
  {
    id: 'i8mmjk11-1483-6c80-3355-8552fh9e7i99',
    name: 'Satış',
    type: 'sales',
    branchId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    manager: 'Ahmet Demir',
    email: 'satis.istanbul@pisaeducazione.com',
    phone: '+90 212 555 0104',
    isActive: true,
    createdAt: new Date('2023-04-15'),
    totalStudents: 45,
    monthlyTarget: 25,
    currentMonthApplications: 18,
    specializations: ['Lead Takibi', 'Müşteri İlişkileri', 'Satış Süreci'],
    description: 'Lead dönüşümü ve satış süreçlerini yöneten birim',
    location: 'İstanbul Merkez - 1. Kat',
    workingHours: '09:00 - 19:00',
    capacity: 35,
    employees: [
      {
        id: 'emp-8',
        userId: 'user-6',
        name: 'Ahmet Demir',
        email: 'ahmet.demir@pisaeducazione.com',
        position: 'Satış Müdürü',
        joinDate: new Date('2023-04-15'),
        isActive: true,
        permissions: ['manage_leads', 'view_pipeline', 'close_deals'],
        workload: 88,
        performance: {
          monthlyTarget: 15,
          achieved: 12,
          successRate: 80
        }
      },
      {
        id: 'emp-9',
        userId: 'user-12',
        name: 'Deniz Kaya',
        email: 'deniz.kaya@pisaeducazione.com',
        position: 'Satış Uzmanı',
        joinDate: new Date('2023-10-01'),
        isActive: true,
        permissions: ['manage_leads', 'view_pipeline'],
        workload: 70,
        performance: {
          monthlyTarget: 10,
          achieved: 6,
          successRate: 60
        }
      }
    ]
  },
  {
    id: 'j9nnkl00-0392-5b7f-2244-7441gi0f8j00',
    name: 'Müşteri Hizmetleri',
    type: 'customer_service',
    branchId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    manager: 'Zeynep Kara',
    email: 'musteri.istanbul@pisaeducazione.com',
    phone: '+90 212 555 0105',
    isActive: true,
    createdAt: new Date('2023-04-20'),
    totalStudents: 44,
    monthlyTarget: 0,
    currentMonthApplications: 0,
    specializations: ['Müşteri Destek', 'Şikayet Yönetimi', 'After-Sales'],
    description: 'Müşteri memnuniyeti ve destek hizmetleri sunan birim',
    location: 'İstanbul Merkez - 4. Kat',
    workingHours: '08:00 - 20:00',
    capacity: 25,
    employees: [
      {
        id: 'emp-10',
        userId: 'user-13',
        name: 'Zeynep Kara',
        email: 'zeynep.kara@pisaeducazione.com',
        position: 'Müşteri Hizmetleri Müdürü',
        joinDate: new Date('2023-04-20'),
        isActive: true,
        permissions: ['manage_tickets', 'view_feedback', 'handle_complaints'],
        workload: 75,
        performance: {
          monthlyTarget: 0,
          achieved: 0,
          successRate: 95
        }
      }
    ]
  },
  {
    id: 'k0oolm99-9201-4a6e-1133-6330hj1g9k11',
    name: 'Muhasebe',
    type: 'accounting',
    branchId: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    manager: 'Hasan Çelik',
    email: 'muhasebe.istanbul@pisaeducazione.com',
    phone: '+90 212 555 0106',
    isActive: true,
    createdAt: new Date('2023-04-25'),
    totalStudents: 0,
    monthlyTarget: 0,
    currentMonthApplications: 0,
    specializations: ['Mali İşlemler', 'Faturalama', 'Ödeme Takibi', 'Vergi İşlemleri'],
    description: 'Mali işlemler, faturalama ve ödeme takibi yapan birim',
    location: 'İstanbul Merkez - 5. Kat',
    workingHours: '09:00 - 18:00',
    capacity: 20,
    employees: [
      {
        id: 'emp-11',
        userId: 'user-7',
        name: 'Hasan Çelik',
        email: 'hasan.celik@pisaeducazione.com',
        position: 'Muhasebe Müdürü',
        joinDate: new Date('2023-04-25'),
        isActive: true,
        permissions: ['manage_payments', 'view_financial_reports', 'manage_invoices'],
        workload: 70,
        performance: {
          monthlyTarget: 0,
          achieved: 0,
          successRate: 98
        }
      },
      {
        id: 'emp-12',
        userId: 'user-14',
        name: 'Burcu Yıldız',
        email: 'burcu.yildiz@pisaeducazione.com',
        position: 'Mali Müşavir',
        joinDate: new Date('2023-11-01'),
        isActive: true,
        permissions: ['manage_payments', 'manage_invoices'],
        workload: 60,
        performance: {
          monthlyTarget: 0,
          achieved: 0,
          successRate: 95
        }
      }
    ]
  },
  {
    id: 'l1ppnm22-2605-6d02-4466-9663fk1h9l22',
    name: 'Eğitim Danışmanlığı',
    type: 'education_consultant',
    branchId: 'f5aa9c77-6958-4be5-8800-3007ce6c4f77',
    manager: 'Deniz Kara',
    email: 'egitim.kadikoy@pisaeducazione.com',
    phone: '+90 216 555 0201',
    isActive: true,
    createdAt: new Date('2024-01-10'),
    totalStudents: 32,
    monthlyTarget: 12,
    currentMonthApplications: 9,
    specializations: ['Üniversite Seçimi', 'Program Danışmanlığı', 'Kariyer Planlama'],
    description: 'Öğrencilere üniversite ve program seçimi konusunda danışmanlık hizmeti veren birim',
    location: 'İstanbul Kadıköy - 1. Kat',
    workingHours: '09:00 - 18:00',
    capacity: 40,
    employees: [
      {
        id: 'emp-15',
        userId: 'user-15',
        name: 'Deniz Kara',
        email: 'deniz.kara@pisaeducazione.com',
        phone: '+90 555 222 3344',
        position: 'Birim Müdürü',
        joinDate: new Date('2024-01-10'),
        isActive: true,
        permissions: ['manage_unit', 'view_all_students', 'edit_students'],
        responsibleUniversities: [
          'Università di Pavia',
          'Università di Parma',
          'Università di Modena',
          'Università di Brescia'
        ],
        workload: 78,
        performance: {
          monthlyTarget: 8,
          achieved: 7,
          successRate: 88
        }
      }
    ]
  },
  {
    id: 'm2qqon11-1514-5c91-3355-8552gl2i8m33',
    name: 'Vize Danışmanlığı',
    type: 'visa_consultant',
    branchId: 'f5aa9c77-6958-4be5-8800-3007ce6c4f77',
    manager: 'Kerem Aydın',
    email: 'vize.kadikoy@pisaeducazione.com',
    phone: '+90 216 555 0202',
    isActive: true,
    createdAt: new Date('2024-01-12'),
    totalStudents: 25,
    monthlyTarget: 10,
    currentMonthApplications: 7,
    specializations: ['Öğrenci Vizesi', 'Schengen Vizesi', 'Vize Başvuru Süreci'],
    description: 'Öğrencilerin vize başvuru süreçlerini yöneten ve takip eden birim',
    location: 'İstanbul Kadıköy - 2. Kat',
    workingHours: '09:00 - 18:00',
    capacity: 30,
    employees: [
      {
        id: 'emp-16',
        userId: 'user-16',
        name: 'Kerem Aydın',
        email: 'kerem.aydin@pisaeducazione.com',
        position: 'Birim Müdürü',
        joinDate: new Date('2024-01-12'),
        isActive: true,
        permissions: ['manage_unit', 'view_all_applications', 'approve_documents'],
        workload: 72,
        performance: {
          monthlyTarget: 7,
          achieved: 5,
          successRate: 71
        }
      }
    ]
  },
  {
    id: 'n3rrpo00-0423-4b80-2244-7441hm3j7n44',
    name: 'Satış',
    type: 'sales',
    branchId: 'f5aa9c77-6958-4be5-8800-3007ce6c4f77',
    manager: 'Selin Tekin',
    email: 'satis.kadikoy@pisaeducazione.com',
    phone: '+90 216 555 0203',
    isActive: true,
    createdAt: new Date('2024-01-15'),
    totalStudents: 18,
    monthlyTarget: 15,
    currentMonthApplications: 11,
    specializations: ['Lead Takibi', 'Müşteri İlişkileri', 'Satış Süreci'],
    description: 'Lead dönüşümü ve satış süreçlerini yöneten birim',
    location: 'İstanbul Kadıköy - 1. Kat',
    workingHours: '09:00 - 19:00',
    capacity: 25,
    employees: [
      {
        id: 'emp-17',
        userId: 'user-17',
        name: 'Selin Tekin',
        email: 'selin.tekin@pisaeducazione.com',
        position: 'Satış Müdürü',
        joinDate: new Date('2024-01-15'),
        isActive: true,
        permissions: ['manage_leads', 'view_pipeline', 'close_deals'],
        workload: 85,
        performance: {
          monthlyTarget: 10,
          achieved: 8,
          successRate: 80
        }
      }
    ]
  },
  {
    id: 'o4ssqp99-9332-3a7f-1133-6330in4k6o55',
    name: 'Müşteri Hizmetleri',
    type: 'customer_service',
    branchId: 'f5aa9c77-6958-4be5-8800-3007ce6c4f77',
    manager: 'Ece Yalçın',
    email: 'musteri.kadikoy@pisaeducazione.com',
    phone: '+90 216 555 0204',
    isActive: true,
    createdAt: new Date('2024-01-18'),
    totalStudents: 12,
    monthlyTarget: 0,
    currentMonthApplications: 0,
    specializations: ['Müşteri Destek', 'Şikayet Yönetimi', 'After-Sales'],
    description: 'Müşteri memnuniyeti ve destek hizmetleri sunan birim',
    location: 'İstanbul Kadıköy - 3. Kat',
    workingHours: '08:00 - 20:00',
    capacity: 20,
    employees: [
      {
        id: 'emp-18',
        userId: 'user-18',
        name: 'Ece Yalçın',
        email: 'ece.yalcin@pisaeducazione.com',
        position: 'Müşteri Hizmetleri Müdürü',
        joinDate: new Date('2024-01-18'),
        isActive: true,
        permissions: ['manage_tickets', 'view_feedback', 'handle_complaints'],
        workload: 68,
        performance: {
          monthlyTarget: 0,
          achieved: 0,
          successRate: 92
        }
      }
    ]
  }
];

export const mockStudents: Student[] = [
  {
    id: 'student-1',
    firstName: 'Zeynep',
    lastName: 'Kara',
    email: 'zeynep.kara@email.com',
    phone: '+90 555 123 4567',
    birthDate: new Date('1998-05-15'),
    nationality: 'Türkiye',
    passportNumber: 'TR123456789',
    branchId: 'branch-1',
    unitId: 'unit-1',
    unitType: 'education_consultant',
    assignedConsultants: ['Fatma Özkan'],
    currentUnit: 'education_consultant',
    unitHistory: [
      {
        unitType: 'education_consultant',
        assignedDate: new Date('2024-01-15'),
        status: 'active'
      }
    ],
    status: 'interested',
    source: 'website',
    interestedCountries: ['İtalya', 'Almanya'],
    interestedPrograms: ['Mühendislik', 'Bilgisayar Bilimleri'],
    interestedUniversities: ['Politecnico di Milano', 'Università Bocconi'],
    academicYear: '2024-2025',
    hasOtherCitizenship: false,
    otherCitizenshipCountry: '',
    hasItalyResidencePermit: false,
    meetingDate: new Date('2024-01-20T14:00:00'),
    meetingConsultant: 'Fatma Özkan',
    meetingType: 'video',
    interestedService: 'education',
    serviceYear: '2024',
    isSeriousCandidate: true,
    visaInfoProvided: true,
    meetingSummary: 'Öğrenci İtalya\'da mühendislik okumak istiyor. Politecnico di Milano\'ya özel ilgisi var. İngilizce seviyesi yeterli, motivasyonu yüksek. Ailesi destekliyor.',
    discussedPrice: '15,000 EUR (Eğitim ücreti) + 2,500 EUR (Hizmet ücreti)',
    hasDiscount: true,
    discountInfo: 'Erken kayıt indirimi: %10 (Şubat ayı sonuna kadar geçerli)',
    contractSent: true,
    formCompleted: true,
    emailSent: true,
    followUpStatus: 'scheduled',
    followUpDate: new Date('2024-01-25'),
    nextMeetingDate: new Date('2024-01-28T15:00:00'),
    nextMeetingPlan: 'Üniversite başvuru belgelerinin kontrolü ve eksik evrakların tamamlanması',
    reminders: 'IELTS sınav tarihi hatırlatılacak, Pasaport yenileme gerekebilir',
    referenceSource: 'Instagram reklamı',
    isRegistered: false,
    budget: '20000-30000 EUR',
    englishLevel: 'B2',
    educationLevel: 'Lisans',
    workExperience: '2 yıl yazılım geliştirme',
    notes: [],
    documents: [],
    applications: [],
    createdAt: new Date('2024-01-15'),
    lastContact: new Date('2024-01-20'),
    nextFollowUp: new Date('2024-01-25'),
    priority: 'high',
    tags: ['mühendislik', 'yazılım', 'avrupa']
  },
  {
    id: 'student-2',
    firstName: 'Ahmet',
    lastName: 'Yıldız',
    email: 'ahmet.yildiz@email.com',
    phone: '+90 555 987 6543',
    birthDate: new Date('1999-08-22'),
    nationality: 'Türkiye',
    branchId: 'branch-1',
    unitId: 'unit-2',
    unitType: 'visa_consultant',
    assignedConsultants: ['Can Kaya'],
    currentUnit: 'visa_consultant',
    unitHistory: [
      {
        unitType: 'sales',
        assignedDate: new Date('2024-01-08'),
        completedDate: new Date('2024-01-10'),
        transferredBy: 'Ahmet Demir',
        status: 'completed'
      },
      {
        unitType: 'visa_consultant',
        assignedDate: new Date('2024-01-10'),
        status: 'active'
      }
    ],
    status: 'applied',
    source: 'referral',
    interestedCountries: ['İtalya', 'İspanya'],
    interestedPrograms: ['İşletme', 'Ekonomi'],
    interestedUniversities: ['Università di Bologna', 'Universidad Complutense Madrid'],
    academicYear: '2025-2026',
    hasOtherCitizenship: true,
    otherCitizenshipCountry: 'Almanya',
    hasItalyResidencePermit: false,
    meetingDate: new Date('2024-01-18T10:30:00'),
    meetingConsultant: 'Can Kaya',
    meetingType: 'in-person',
    interestedService: 'both',
    serviceYear: '2025',
    isSeriousCandidate: true,
    visaInfoProvided: false,
    meetingSummary: 'Öğrenci hem eğitim hem vize danışmanlığı istiyor. Almanya vatandaşlığı avantaj sağlayabilir. Bütçesi uygun, aile desteği var.',
    discussedPrice: '12,000 EUR (Eğitim ücreti) + 3,000 EUR (Vize + Eğitim hizmeti)',
    hasDiscount: false,
    discountInfo: '',
    contractSent: false,
    formCompleted: true,
    emailSent: true,
    followUpStatus: 'pending',
    followUpDate: new Date('2024-01-30'),
    nextMeetingDate: new Date('2024-02-02T11:00:00'),
    nextMeetingPlan: 'Vize başvuru sürecinin detaylı anlatımı ve gerekli belgelerin listesi',
    reminders: 'Almanya vatandaşlık belgesi temin edilecek, Mali durum belgesi hazırlanacak',
    referenceSource: 'Arkadaş tavsiyesi (Zeynep Kara)',
    isRegistered: true,
    leadScore: 72,
    leadScoreFactors: {
      budgetScore: 15,
      documentsScore: 12,
      languageScore: 18,
      experienceScore: 12,
      urgencyScore: 10
    },
    budget: '15000-25000 EUR',
    englishLevel: 'C1',
    educationLevel: 'Lise',
    notes: [],
    documents: [],
    applications: [],
    createdAt: new Date('2024-01-10'),
    lastContact: new Date('2024-01-18'),
    nextFollowUp: new Date('2024-01-28'),
    priority: 'medium',
    tags: ['işletme', 'ekonomi', 'avrupa']
  }
];

export const mockDocuments: Document[] = [
  {
    id: '1',
    studentId: 'student-1',
    name: 'Pasaport_ZeynepKara.pdf',
    type: 'passport',
    url: '/documents/passport.pdf',
    uploadedBy: 'student-1',
    uploadedAt: new Date('2024-01-15'),
    status: 'approved',
    isRequired: true,
    reviewedBy: 'Fatma Özkan',
    reviewedAt: new Date('2024-01-16')
  },
  {
    id: '2',
    studentId: 'student-1',
    name: 'Diploma_ZeynepKara.pdf',
    type: 'diploma',
    url: '/documents/diploma.pdf',
    uploadedBy: 'student-1',
    uploadedAt: new Date('2024-01-18'),
    status: 'pending',
    isRequired: true
  },
  {
    id: '3',
    studentId: 'student-1',
    name: 'CV_ZeynepKara.pdf',
    type: 'cv',
    url: '/documents/cv.pdf',
    uploadedBy: 'student-1',
    uploadedAt: new Date('2024-01-20'),
    status: 'revision-required',
    isRequired: true,
    notes: 'Lütfen iş deneyimi bölümünü daha detaylandırın',
    reviewedBy: 'Fatma Özkan',
    reviewedAt: new Date('2024-01-21')
  }
];

export const mockNotes: Note[] = [
  {
    id: 'note-1',
    studentId: 'student-1',
    userId: 'user-1',
    userName: 'Fatma Özkan',
    content: 'Öğrenci İtalya\'daki mühendislik programları hakkında detaylı bilgi istedi. Politecnico di Milano önerisi yapıldı.',
    type: 'call',
    createdAt: new Date('2024-01-20'),
    isPrivate: false
  }
];

export const mockApplications: Application[] = [
  {
    id: 'app-1',
    studentId: 'student-2',
    studentName: 'Ahmet Yıldız',
    country: 'İtalya',
    university: 'Bocconi Üniversitesi',
    program: 'İşletme Yönetimi',
    degree: 'Lisans',
    startDate: new Date('2024-09-01'),
    applicationFee: 100,
    tuitionFee: 14000,
    status: 'submitted',
    submittedAt: new Date('2024-01-18'),
    documents: ['passport', 'transcript', 'language-certificate'],
    submittedBy: 'Fatma Özkan',
    requirements: ['IELTS 6.5', 'Lise Diploması', 'Motivasyon Mektubu'],
    deadline: new Date('2024-03-15')
  }
];

export const mockActivities: Activity[] = [
  {
    id: 'activity-1',
    type: 'student_created',
    userId: 'user-1',
    userName: 'Fatma Özkan',
    studentId: 'student-1',
    studentName: 'Zeynep Kara',
    description: 'Yeni öğrenci kaydı oluşturuldu',
    createdAt: new Date('2024-01-15')
  },
  {
    id: 'activity-2',
    type: 'note_added',
    userId: 'user-1',
    userName: 'Fatma Özkan',
    studentId: 'student-1',
    studentName: 'Zeynep Kara',
    description: 'Telefon görüşmesi notu eklendi',
    createdAt: new Date('2024-01-20')
  }
];

export const mockDashboardStats: DashboardStats = {
  totalStudents: 1247,
  newStudentsThisMonth: 89,
  activeApplications: 234,
  acceptedApplications: 156,
  revenue: 2450000,
  conversionRate: 68.5,
  averageProcessingTime: 14,
  topCountries: [
    { country: 'İtalya', count: 456 },
    { country: 'Almanya', count: 234 },
    { country: 'İspanya', count: 189 },
    { country: 'Fransa', count: 167 },
    { country: 'Hollanda', count: 123 }
  ],
  topPrograms: [
    { program: 'Mühendislik', count: 234 },
    { program: 'İşletme', count: 189 },
    { program: 'Tıp', count: 156 },
    { program: 'Hukuk', count: 134 },
    { program: 'Mimarlık', count: 98 }
  ],
  monthlyStats: [
    { month: 'Oca', students: 89, applications: 67, revenue: 890000 },
    { month: 'Şub', students: 76, applications: 54, revenue: 760000 },
    { month: 'Mar', students: 92, applications: 71, revenue: 920000 },
    { month: 'Nis', students: 85, applications: 63, revenue: 850000 },
    { month: 'May', students: 78, applications: 58, revenue: 780000 },
    { month: 'Haz', students: 94, applications: 73, revenue: 940000 }
  ]
};

export const mockDeadlines: Deadline[] = [
  {
    id: 'deadline-1',
    title: 'İtalya Üniversiteleri Bahar Dönemi Başvuru Deadline',
    description: 'İtalya\'daki tüm üniversiteler için 2024 Bahar dönemi başvuru son tarihi yaklaşıyor.',
    type: 'application',
    dueDate: new Date('2024-03-15'),
    priority: 'high',
    affectedUsers: ['user-3', 'user-8', 'user-9'], // Eğitim danışmanları
    affectedStudents: ['student-1', 'student-2', 'student-3'],
    createdBy: 'Admin User',
    createdAt: new Date('2024-01-01'),
    isActive: true,
    reminderDays: [30, 14, 7, 3, 1],
    category: 'university',
    relatedUniversities: [
      'Politecnico di Milano',
      'Università Bocconi',
      'Università Statale Milano',
      'Università di Roma La Sapienza',
      'Università di Bologna'
    ],
    relatedCountries: ['İtalya'],
    requirements: ['Tüm belgeler tamamlanmış olmalı', 'Dil belgesi geçerli olmalı', 'Başvuru ücreti ödenmiş olmalı'],
    actionRequired: 'Öğrencilerin başvuru belgelerini kontrol edin ve eksikleri tamamlayın',
    contactPerson: 'Fatma Özkan',
    contactEmail: 'egitim@pisaeducazione.com'
  },
  {
    id: 'deadline-2',
    title: 'Öğrenci Vizesi Başvuru Deadline',
    description: 'İtalya öğrenci vizesi için başvuru son tarihi. Kabul mektubu alan öğrenciler için geçerli.',
    type: 'visa',
    dueDate: new Date('2024-04-30'),
    priority: 'critical',
    affectedUsers: ['user-4', 'user-10'], // Vize danışmanları
    affectedStudents: ['student-2', 'student-3'],
    createdBy: 'Admin User',
    createdAt: new Date('2024-01-01'),
    isActive: true,
    reminderDays: [45, 30, 14, 7, 3],
    category: 'visa',
    relatedCountries: ['İtalya'],
    requirements: ['Kabul mektubu', 'Pasaport', 'Mali durum belgesi', 'Sağlık sigortası'],
    actionRequired: 'Vize başvuru belgelerini hazırlayın ve randevu alın',
    contactPerson: 'Can Kaya',
    contactEmail: 'vize@pisaeducazione.com'
  },
  {
    id: 'deadline-3',
    title: 'Eğitim Ücreti Ödeme Deadline',
    description: 'İtalya üniversiteleri için ilk dönem eğitim ücreti ödeme son tarihi.',
    type: 'payment',
    dueDate: new Date('2024-08-15'),
    priority: 'high',
    affectedUsers: ['user-7', 'user-14'], // Muhasebe
    affectedStudents: ['student-1', 'student-2', 'student-3'],
    createdBy: 'Admin User',
    createdAt: new Date('2024-01-01'),
    isActive: true,
    reminderDays: [60, 30, 14, 7, 3],
    category: 'payment',
    relatedCountries: ['İtalya'],
    requirements: ['Kabul mektubu alınmış olmalı', 'Banka hesabı açılmış olmalı'],
    actionRequired: 'Öğrencilerin ödeme planlarını kontrol edin',
    contactPerson: 'Hasan Çelik',
    contactEmail: 'muhasebe@pisaeducazione.com'
  },
  {
    id: 'deadline-4',
    title: 'IELTS Sınav Kayıt Deadline',
    description: 'İtalya üniversiteleri için gerekli IELTS sınavına kayıt son tarihi.',
    type: 'document',
    dueDate: new Date('2024-02-28'),
    priority: 'medium',
    affectedUsers: ['user-3', 'user-8', 'user-9'], // Eğitim danışmanları
    affectedStudents: ['student-1', 'student-4'],
    createdBy: 'Admin User',
    createdAt: new Date('2024-01-01'),
    isActive: true,
    reminderDays: [21, 14, 7, 3],
    category: 'document',
    relatedCountries: ['İtalya'],
    requirements: ['IELTS sınav ücreti', 'Pasaport fotokopisi'],
    actionRequired: 'Öğrencilerin IELTS sınav kaydını yaptırın',
    contactPerson: 'Fatma Özkan',
    contactEmail: 'egitim@pisaeducazione.com'
  },
  {
    id: 'deadline-5',
    title: 'İtalya Konsolosluk Randevu Deadline',
    description: 'İtalya konsolosluk vize randevusu için son başvuru tarihi.',
    type: 'visa',
    dueDate: new Date('2024-05-15'),
    priority: 'high',
    affectedUsers: ['user-4', 'user-10'], // Vize danışmanları
    affectedStudents: ['student-2', 'student-3'],
    createdBy: 'Admin User',
    createdAt: new Date('2024-01-01'),
    isActive: true,
    reminderDays: [30, 14, 7, 3],
    category: 'visa',
    relatedCountries: ['İtalya'],
    requirements: ['Tüm vize belgeleri hazır', 'Randevu ücreti'],
    actionRequired: 'Konsolosluk randevusu alın',
    contactPerson: 'Can Kaya',
    contactEmail: 'vize@pisaeducazione.com'
  }
];

export const mockDeadlineNotifications: DeadlineNotification[] = [
  {
    id: 'notif-1',
    deadlineId: 'deadline-1',
    userId: 'user-3',
    studentId: 'student-1',
    title: 'İtalya Başvuru Deadline Yaklaşıyor',
    message: 'Zeynep Kara için İtalya üniversiteleri başvuru deadline\'ı 15 gün sonra sona eriyor.',
    daysLeft: 15,
    priority: 'high',
    isRead: false,
    createdAt: new Date('2024-01-20'),
    actionUrl: '/students/student-1'
  },
  {
    id: 'notif-2',
    deadlineId: 'deadline-2',
    userId: 'user-4',
    studentId: 'student-2',
    title: 'Vize Başvuru Deadline',
    message: 'Ahmet Yıldız için İtalya öğrenci vizesi başvuru deadline\'ı yaklaşıyor.',
    daysLeft: 30,
    priority: 'critical',
    isRead: false,
    createdAt: new Date('2024-01-22'),
    actionUrl: '/visa/student-2'
  },
  {
    id: 'notif-3',
    deadlineId: 'deadline-4',
    userId: 'student-1',
    title: 'IELTS Sınav Kayıt Deadline',
    message: 'IELTS sınavına kayıt için son 7 gün kaldı. Hemen kayıt olun!',
    daysLeft: 7,
    priority: 'medium',
    isRead: false,
    createdAt: new Date('2024-01-21'),
    actionUrl: '/documents'
  }
];

export const mockProposals: Proposal[] = [];

export const mockDealers: Dealer[] = [
  {
    id: 'dealer-1',
    name: 'İstanbul Eğitim Merkezi',
    code: 'IEM001',
    city: 'İstanbul',
    region: 'Marmara',
    contactPerson: 'Ali Veli',
    email: 'istanbul@egitimmerkezi.com',
    phone: '+90 212 555 0001',
    address: 'Kadıköy Mahallesi, Bağdat Cad. No:123, Kadıköy/İstanbul',
    isActive: true,
    createdAt: new Date('2023-01-15'),
    totalStudents: 45,
    monthlyTarget: 20,
    currentMonthApplications: 12
  },
  {
    id: 'dealer-2',
    name: 'Ankara Danışmanlık',
    code: 'AD001',
    city: 'Ankara',
    region: 'İç Anadolu',
    contactPerson: 'Ayşe Yılmaz',
    email: 'ankara@danismanlik.com',
    phone: '+90 312 555 0002',
    address: 'Kızılay Mahallesi, Atatürk Bulvarı No:456, Çankaya/Ankara',
    isActive: true,
    createdAt: new Date('2023-02-20'),
    totalStudents: 32,
    monthlyTarget: 15,
    currentMonthApplications: 8
  }
];

// Satış departmanı mock data'ları temizlendi - artık Supabase'den gelecek

export const getUnitTypeName = (type: UnitType): string => {
  switch (type) {
    case 'education_consultant': return 'Eğitim Danışmanı';
    case 'visa_consultant': return 'Vize Danışmanı';
    case 'marketing': return 'Pazarlama';
    case 'accounting': return 'Muhasebe';
    case 'customer_service': return 'Müşteri Hizmetleri';
    case 'sales': return 'Satış';
    case 'testprep': return 'Test Hazırlık';
    case 'teknik_destek': return 'Teknik Destek';
    default: return type;
  }
};